import dynamic from "next/dynamic";

export const Content = dynamic(() => import("./component"));
